import React from 'react';
import { FiMonitor } from 'react-icons/fi';
import '../broadcastNext.css';

/**
 * Asked before the whiteboard opens: the board is only visible to students if the teacher's
 * screen is being shared, and the browser's screen picker needs a real click to open —
 * "Allow & share" is that click.
 */
const ShareScreenModal = ({
  title = 'Share your screen?',
  body = 'The whiteboard needs screen sharing to be enabled. Allow Broadcast to share your screen so students can see the whiteboard.',
  confirmLabel = 'Allow & share',
  cancelLabel = 'Cancel',
  onCancel,
  onConfirm,
}) => (
  <div className="bn-modal-overlay" role="dialog" aria-modal="true" aria-label={title}>
    <div className="bn-modal">
      <div className="bn-modal-head">
        <div className="bn-modal-icon">
          <FiMonitor size={20} />
        </div>
        <div className="bn-modal-title">{title}</div>
      </div>

      <div className="bn-modal-body">{body}</div>

      <div className="bn-modal-actions">
        <button type="button" className="bn-modal-cancel" onClick={onCancel}>
          {cancelLabel}
        </button>
        <button type="button" className="bn-modal-confirm" onClick={onConfirm}>
          {confirmLabel}
        </button>
      </div>
    </div>
  </div>
);

export default ShareScreenModal;
